import React from 'react';
import {
  Loader,
  //  MessageView
} from '../../../@crema';
import {useSelector} from 'react-redux';
import {AppState} from '../../../redux/store';
// import GifLoading from '@shared/gifLoading';

interface InfoViewProps {}

const InfoView: React.FC<InfoViewProps> = () => {
  const common = useSelector<AppState, AppState['common']>(
    ({common}) => common,
  );
  const {
    // error,
    loading,
    // message
  } = common;

  // const showMessage = () => {
  //   return <MessageView variant='success' message={message.toString()} />;
  // };

  // const showError = () => {
  //   return <MessageView variant='error' message={error.toString()} />;
  // };

  return (
    <>
      {loading && <Loader />}
      {/* {message && showMessage()}
      {error && showError()} */}
    </>
  );
};

export default InfoView;
